import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugmvyztm6r: FaireProductEntity = {
  token: "p_ugmvyztm6r",
  type: "product",
  name: "Owen Shirt  (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/3bc8ac3c6ad08c7736f85c2671c3767fdc438a851dbbe82f114ec66c8a3ccefd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58b24ad25db71b5cde58d4fbb4d0d427fa6f9ca26b2b8311d2dfa0c3247aa531.jpeg",
    "https://cdn.faire.com/fastly/1632424d504cb34d11f0ba8a5284c410ed95eb1c663385a9a947e1bab36ba25e.jpeg",
    "https://cdn.faire.com/fastly/7dd3b513de9b523e5389187eaafaad4d2ab886baceb18fc22a356f0b48fb5516.jpeg",
    "https://cdn.faire.com/fastly/e209b5aa64c450e2b27127436dd937d225e1b3c6cd49a40a9b9c845aabb0a0ae.jpeg",
    "https://cdn.faire.com/fastly/7d06014b25b2228e32cc27cb3e7b3653944d4fb7316c228be00cd8f2b0c628c0.jpeg",
    "https://cdn.faire.com/fastly/0bae034ef711d17a239807c8bea22ef405fdd18dfe82d6b811bf01b910e8b0fc.jpeg",
    "https://cdn.faire.com/fastly/753891cb3227aa4048c6bcd961d73d11d5ae8df51cacd1fa8bfd2fdc4c91f52e.jpeg",
    "https://cdn.faire.com/fastly/44df3965da702d31e03d774e06a87eecbbe6ccc1e95ee333e32739582d04567b.jpeg",
    "https://cdn.faire.com/fastly/31ba3ab45de64000338ab159f42da644dcb05a8d2b40fef8b51bae2fec682083.jpeg",
    "https://cdn.faire.com/fastly/022dac80fa917f73ff5652bc562fa582e343faa7ab3e26d0af7099ec0e321d96.jpeg",
  ],
  priceDollars: 240,
  description:
    '𝗪𝗵𝘆 𝗪𝗲 𝗠𝗮𝗱𝗲 𝗧𝗵𝗶𝘀?\n\nThe classic denim shirt, reimagined. It fits like the perfect vintage \'90s piece—slightly oversized and relaxed for easy layering, or wear it as a lightweight jacket. Made from 100% heavy cotton denim, it\'s soft yet durable, ideal for both casual and elevated looks. Featuring functional buttons, contrast stitching, and a classic rounded hem, it\'s a timeless, versatile wardrobe essential that transcends time.\n\n\n\n𝗣𝗹𝗲𝗮𝘀𝗲 𝗻𝗼𝘁𝗲:\n\nColors - The washing process gives each garment unique character. Please allow for slight color and fit variation for each garment as is the beauty of garment wash. Pieces with the same color name may not match exactly.\n\n\n\n𝗖𝗼𝗻𝘁𝗲𝗻𝘁𝘀:\n\n100% Cotton Heavy Weight Denim\n\n\n𝗖𝗮𝗿𝗲 𝗜𝗻𝘀𝘁𝗿𝘂𝗰𝘁𝗶𝗼𝗻𝘀:\n\n• Washing these garments only with like colors and in cold water\n• Recommend to Hang Dry for the best result!\n\n\n\n𝗔𝗽𝗽𝗿𝗼𝘅𝗶𝗺𝗮𝘁𝗲 𝗠𝗲𝗮𝘀𝘂𝗿𝗲𝗺𝗲𝗻𝘁𝘀:\n\n• XS/S: Length: 29", Chest: 25"\n• M/L: Length: 29 1/2, Chest: 25 1/2"\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS/S\n\n\n\nMade in China\n\nMSRP: $125 USD',
  tags: [],
  msrpDollars: 500,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:11.745Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
